/****************************************************
 * Module Name:  addMixShapeModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import MixShapeProxy from "../../utility/proxy/manager/mixProxy/mixShapeProxy";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddMixShapeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newshape: this.props.editOperation ? this.props.sourceData.name : "",
      newshapefullname: this.props.editOperation
        ? this.props.sourceData.fullname
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",

      showError: false,

      validateShapePresentSpinner: false,
      showValidationMessage: false,
      shapeAvailable: true,

      shapeValidationError: "",
      fullNameValidationError: "",
      newseq: this.props.editOperation ? this.props.sourceData.seq : "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newshape,
      fullname: this.state.newshapefullname,
      description: this.state.newdescription,
      seq: this.state.newseq
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateShapePresent = (shapeEntered) => {
    if (!shapeEntered || shapeEntered.trim() === "") return;

    this.setState({
      validateShapePresentSpinner: true,
    });

    MixShapeProxy.CheckShapeAvailable(shapeEntered, (response) => {
      //if we got response that means shape is present at backend
      if (response) {
        //ShapeName already present
        this.setState({
          validateShapePresentSpinner: false,
          showValidationMessage: true,
          shapeAvailable: false,
        });
      } else {
        //ShapeName not available, so can be used
        this.setState({
          validateShapePresentSpinner: false,
          showValidationMessage: true,
          shapeAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (!this.props.editOperation)
      return !this.state.showValidationMessage || !this.state.shapeAvailable;

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add shape validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Shape" : "Add New Shape"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Shape Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Shape <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newshape.trim()}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Shape (required)"
                          placeholder="Enter Shape"
                          value={this.state.newshape}
                          autoFocus
                          onBlur={(e) =>
                            this.validateShapePresent(this.state.newshape.trim())
                          }
                          onChange={(e) =>
                            this.setState({
                              newshape: e.target.value.trim(),
                              showValidationMessage: false,
                              shapeValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Shape Cannot be Empty",
                            })
                          }
                          helperText={this.state.shapeValidationError}
                          error={this.state.shapeValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateShapePresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.shapeAvailable ? (
                        <font color="green">Shape available</font>
                      ) : (
                        <font color="red">Shape not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <Form.Label>Sequence</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Sequence"
                        placeholder="Enter Sequence"
                        value={this.state.newseq}
                        onChange={(e) =>
                          this.setState({ newseq: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
